const typeGroupPublisher = {
  BANNER: "banner",
  NATIVE: "native",
  PUSH: "push",
};

const getTypeGroupPublisherNumber = () => {
  let data = {};
  data[typeGroupPublisher.BANNER] = 1;
  data[typeGroupPublisher.NATIVE] = 2;
  data[typeGroupPublisher.PUSH] = 3;

  return data;
};

const getTypeGroupPublisherPersianName = () => {
  let data = {};
  data[typeGroupPublisher.BANNER] = "بنری";
  data[typeGroupPublisher.NATIVE] = "همسان";
  data[typeGroupPublisher.PUSH] = "پوش";

  return data;
};

const getTypePersianNameGroupPublisher = (status) => {
  return getTypeGroupPublisherPersianName()[status];
};
const getTypeGroupPublisher = (status) => {
  return getTypeGroupPublisherNumber()[status];
};

export default {
  getTypePersianNameGroupPublisher,
  getTypeGroupPublisher,
  typeGroupPublisher,
};
